import React from 'react';

import PropTypes from 'prop-types';

import { Modal } from 'react-magma-dom';

import ModalContent from './Content';


const SelectParametersModal = ({ isOpen, onCloseModal, defaultTypesVariables }) =>
  <Modal
    header="Select Variables"
    className="select-parameters-modal"
    isOpen={isOpen}
    onClose={onCloseModal}
  >
    <ModalContent onCloseModal={onCloseModal} defaultTypesVariables={defaultTypesVariables} />
  </Modal>;

SelectParametersModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  defaultTypesVariables: PropTypes.object.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default SelectParametersModal;
